export default "__VITE_ASSET__CzfIEKXj__"